import React from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import i18next from 'i18next';

import { PageTitle } from '../PageTitle';
import UserEditForm from './user_edit_form';
import { Message } from '../Message';
import { UsersService, RolesService, LocalesService } from '../../services';
import { FormatHelper } from '../../helpers';

@connect(state => {
  return {
    me: state.user.me
  }
})
class UserAdd extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      added: null,
      user: null,
      enterprise: this.props.me.enterprise,
      availableRoles: null,
      errorMessage: null,
      localErrorMessage: null,
      roleTypes: null
    };
  }

  componentDidMount() {
    RolesService.listAll().then((response) => {
      this.setState({ availableRoles: response.roles });
    }).catch((error) => {
      this.setState({ errorMessage: i18next.t('messages.could-not-load-roles') });
      console.error(error);
    });

    RolesService.getAllRoleTypes().then((response) => {
      let roleTypes = response.roleTypes.filter(type => type.token != "responsibility_role")
      this.setState({ roleTypes: roleTypes });
    }).catch((error) => {
      this.setState({ errorMessage: i18next.t('messages.could-not-load-role-types')});
      console.error(error);
    });

    let user = {
      firstName: '',
      lastName: '',
      email: '',
      password: '',
      enterprise: this.props.me.enterprise,
      roles: []
    };

    const defaultLocale = this.props.me.enterprise.enterprisePreferences.find(preference => preference.token === 'DEFAULT_LOCALE_LANGUAGE_TAG');

    if (defaultLocale && defaultLocale.stringValue) {
      LocalesService.getByLanguageTag(defaultLocale.stringValue).then(response => {
        user.locale = response.locale;
        this.setState({user});
      }).catch(error => {
        console.error(error);
        user.locale = {};
        this.setState({user});
      });
    } else {
      user.locale = {};
      this.setState({user});
    }

  }

  handleSubmit(userData) {
    this.setState({localErrorMessage: null, localSuccessMessage: null});

    if (userData.button === 'testNotificationPreferences') {
      return this.handleTestNotificationPreferences(userData);
    }

    const user = {};
    user.firstName = userData.firstName;
    user.lastName = userData.lastName;
    user.username = userData.username;
    user.temperatureDisplayUnit = userData.temperatureDisplayUnit.value;
    user.roles = [];
    user.enterprise = this.state.enterprise;
    user.password = userData.password;
    user.archived = false;
    user.locale = userData.locale.value;

    user.notificationPreferences = FormatHelper.formatPhoneNumbers(userData.smsPreferences.filter(pref => pref.sms && pref.sms !== ''))
      .concat(FormatHelper.formatPhoneNumbers(userData.voicePreferences.filter(pref => pref.voice?.number && pref.voice?.number !== ''), "voice"))
      .concat(userData.emailPreferences.filter(pref => pref.email && pref.email !== ''));

    this.state.roleTypes.forEach(type => {userData.roles[type.token].forEach(role => user.roles.push({id: role.value}))});

    UsersService.add(user).then(user => {
      this.setState({ added: user });
    }).catch(error => {
      console.error(error);
      this.setState({ localErrorMessage: error.message });
    });
  }

  messageDismissCallback() {
    this.setState({ localSuccessMessage: null, localErrorMessage: null });
  }

  renderMessages() {
    if (this.state.localErrorMessage || this.state.localSuccessMessage) {
      return (
          <Message  messages={{ state: { successMessage: this.state.localSuccessMessage } }} errorMessage={this.state.localErrorMessage} messageDismissCallback={this.messageDismissCallback.bind(this)} />
      );
    }

    return null;
  }

  render() {
    if (this.state.errorMessage) {
      return (
          <Redirect to={{
            pathname: '/admin/users',
            state: {
              errorMessage: this.state.errorMessage
            }
          }}/>
      );
    }

    if (this.state.added) {
      return (
          <Redirect to={{
            pathname: '/admin/users',
            state: {
              from: this.props.location,
              successMessage: i18next.t('messages.user-added')
            }
          }}/>
      );
    } else {
      if (this.state.user && this.state.enterprise && this.state.availableRoles && this.state.roleTypes) {
        const backLinkSearch = this.props.location.state && this.props.location.state.backLinkSearch ? this.props.location.state.backLinkSearch : null;
        const searchTerms = this.props.location.state && this.props.location.state.searchTerms ? this.props.location.state.searchTerms : null;
        return (
            <div>
              <div className="row">
                <PageTitle title={i18next.t('pages.users.add-user')}
                           backLinkWithParams= {{
                             link: {
                               pathname: "/admin/users",
                               search: backLinkSearch,
                               searchTerms: searchTerms
                             }
                           }} />
              </div>
              {this.renderMessages()}
              <div className="op-content-box">
                <UserEditForm
                    user={this.state.user}
                    onSubmit={this.handleSubmit.bind(this)}
                    availableRoles={this.state.availableRoles}
                    roleTypes={this.state.roleTypes}
                    backLinkWithParams= {{
                      link: {
                        pathname: "/admin/users",
                        search: backLinkSearch
                      }
                    }}
                />
              </div>
            </div>
        );
      } else {
        return (
            <div className="loader">{i18next.t('loading')}</div>
        );
      }
    }
  }

}

export default UserAdd;
